import React, { useState } from 'react';
import { ServiceResponse } from '../../hooks/useFetch';

type Props = {
  callbackSave: () => Promise<any> | any;
  locked?: boolean;
  onComplete?: (ok: boolean, resp?: ServiceResponse) => void;
  children?: React.ReactNode;
};

const ButtonSaveForm: React.FC<Props> = ({ callbackSave, locked = false, onComplete, children }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (locked || loading) return;
    setLoading(true);
    try {
      const resp = await callbackSave();
      // considerar éxito si backend devuelve status === 1 o http_status 200/201
      const ok =
        Boolean(resp) &&
        (resp.status === 1 || resp.http_status === 200 || resp.http_status === 201);

      onComplete?.(ok, resp);
    } catch (err: any) {
      console.error('[ButtonSaveForm] save error', err);
      onComplete?.(false, { message: err?.message ?? 'Network error' } as ServiceResponse);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button" className="btn-save" onClick={handleClick} disabled={locked || loading}>
      {loading ? 'Guardando...' : children ?? 'Guardar'}
    </button>
  );
};

export default ButtonSaveForm;
